<section class="video-upload" [ngClass]="{ 'hide-all': isUploading }">
  <div class="upload-form-column">
    <h2>Subir Video</h2>
    <form [formGroup]="uploadForm">
      <div class="form-group">
        <label for="title">Título del video</label>
        <input
          id="title"
          formControlName="title"
          type="text"
          placeholder="Introduce el título del vídeo..."
        />
        <div *ngIf="uploadForm.get('title').invalid && uploadForm.get('title').touched" class="error-message">
          <span *ngIf="uploadForm.get('title').errors['required']">El título es obligatorio.</span>
          <span *ngIf="uploadForm.get('title').errors['minlength']">El título debe tener al menos 3 caracteres.</span>
        </div>
      </div>
      <div class="form-group">
        <label for="description">Descripción</label>
        <textarea
          id="description"
          formControlName="description"
          placeholder="Añade una descripción del vídeo..."
        ></textarea>
        <div *ngIf="uploadForm.get('description').invalid && uploadForm.get('description').touched" class="error-message">
          <span *ngIf="uploadForm.get('description').errors['required']">La descripción es obligatoria.</span>
        </div>
      </div>
      <div class="form-group">
        <ng-content></ng-content>
      </div>
    </form>
  </div>
  <div class="upload-form-column upload-file-column">
    <app-rfebm-primary-button
      [isDisabled]="!selectedFile || uploadForm.invalid"
      (click)="onUploadButtonClick()">
      Subir video
    </app-rfebm-primary-button>

    <app-drag-drop-files
      [label]="'Arrastra y suelta tu video aquí'"
      [allowMultipleFiles]="false"
      [allowedExtensions]="['.mp4', '.avi', '.mov']"
      (onFilesDropped)="onFileSelected($event)"
    ></app-drag-drop-files>

    <div *ngIf="errorMessage" class="error-alert">
      {{ errorMessage }}
    </div>
  </div>
</section>

@if (isUploading) {
<section class="progress-bar">
  <app-progress-bar
    [title]="uploadTitle"
    [progress]="uploadProgress"
    [subtitle]="uploadSubtitle"
  ></app-progress-bar>
</section>
}
